import type { FC } from 'react';
import { X } from 'lucide-react';

export type IpcFilterChipItem = { key: string; label: string };

type Props = {
  items: IpcFilterChipItem[];
  onRemove: (key: string) => void;
  /** 清除全部筛选值（空条件），不是恢复默认 */
  onClearAll: () => void;
};

export const IpcFilterChips: FC<Props> = ({ items, onRemove, onClearAll }) => {
  if (items.length === 0) return null;
  return (
    <div className="ipc-filter-chips" aria-label="已应用筛选">
      <span className="ipc-filter-chips__label">已应用筛选:</span>
      {items.map(item => (
        <span className="ipc-filter-chip" key={item.key}>
          {item.label}
          <button
            type="button"
            className="ipc-filter-chip__remove"
            onClick={() => onRemove(item.key)}
            aria-label={`移除${item.label}`}
          >
            <X size={12} />
          </button>
        </span>
      ))}
      <button type="button" className="ipc-filter-chips__clear" onClick={onClearAll}>
        清除全部
      </button>
    </div>
  );
};
